import { render, staticRenderFns } from "./departEndEdit.vue?vue&type=template&id=ab181046&scoped=true"
import script from "./departEndEdit.vue?vue&type=script&lang=js"
export * from "./departEndEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab181046",
  null
  
)

export default component.exports